import { useARC } from "providers/ARC/ARCProvider";
import { useLightControl } from "providers/ARC/LightControlProvider";

import FunctionalButton from "components/layout/FunctionalButton";

import { ConnectionState } from "lib/consts/ARC/connection";
import { LightState } from "lib/consts/ARC/light";

import { ReactComponent as FlashOffIcon } from "assets/svgs/ARC/FlashOff.svg";
import { ReactComponent as FlashOnIcon } from "assets/svgs/ARC/FlashOn.svg";

const FlashButton = () => {
    const { connectionState } = useARC();
    const { flashState, toggleFlash, isFlashToggling } = useLightControl();

    const isConnectedToARC = connectionState === ConnectionState.Connected;

    return (
        <FunctionalButton
            className={`control-button-type3 ${
                flashState === LightState.ON && "control-button-active"
            } ${(!isConnectedToARC || isFlashToggling) && "control-button-disable"}`}
            icon={
                connectionState === ConnectionState.Connected ? (
                    flashState === LightState.ON ? (
                        <FlashOnIcon className="w-6" />
                    ) : (
                        <FlashOffIcon className="w-6" />
                    )
                ) : (
                    <FlashOffIcon className="w-6 text-black70" />
                )
            }
            hoverText="Flash"
            disabled={!isConnectedToARC || isFlashToggling}
            onClick={() => toggleFlash()}
        />
    );
};

export default FlashButton;
